/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PassType {
  PUNCH_BASED = 'punch_based',
  UNLIMITED_MONTHLY = 'unlimited_monthly',
  FIXED_SCHEDULE_MONTHLY = 'fixed_schedule_monthly',
}
